// Scroll fade-in animation for sections
(function() {
  'use strict';

  function initScrollFade() {
    // Configuration
    const config = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    // Create intersection observer
    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          // Optional: stop observing after animation completes
          // observer.unobserve(entry.target);
        }
      });
    }, config);

    // Find all sections with fade-on-scroll class
    const sections = document.querySelectorAll('.fade-on-scroll');
    
    // Observe each section
    sections.forEach(function(section) {
      observer.observe(section);
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollFade);
  } else {
    initScrollFade();
  }
})();